import { render, staticRenderFns } from "./registroInformacion.vue?vue&type=template&id=1967fbf8"
import script from "./registroInformacion.vue?vue&type=script&lang=js"
export * from "./registroInformacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports